<template>
    <Card
        icon="fas fa-ticket-alt"
        bg-color="tw:bg-[var(--sitecolor)]"
        title-color="white"
        title-classes="tw:border-b tw:border-gray-200"
        :title="'Ticketing'"
        padding="0"
    >
        <div class="tw:p-6 tw:space-y-4">
            <BaseInputNumber
                id="n_max_asientos_pedido"
                name="n_max_asientos_pedido"
                :label="'Nº max de asientos por pedido'"
                :value="localData.n_max_asientos"
                :min="1"
                @input="val => localData.n_max_asientos = val"
            />

            <div class="tw:border-t tw:border-gray-100 tw:mb-4"></div>

            <div class="tw:space-y-3">
                <ToggleSwitch
                    :value="localData.permitir_liberacion_asientos"
                    @input="val => localData.permitir_liberacion_asientos = val"
                    variant="success"
                >
                    {{ 'Permitir liberación de asientos' }}
                </ToggleSwitch>

                <ToggleSwitch
                    id="checkbox_permitir_cesion_temporal_asiento"
                    :value="localData.permitir_cesion_temporal_asiento"
                    @input="val => set(localData, 'permitir_cesion_temporal_asiento', val)"
                    :disabled="!puedeConfigurarCesionTemporal"
                    variant="primary"
                    data-cy="permitir-cesion-temporal-asiento"
                >
                    {{ 'Permitir cesión temporal del asiento' }}
                    <Tooltip
                        :text="cesionTemporalMensajeTooltip || cesionTemporalBloqueadaPor"
                        variant="success"
                    />
                </ToggleSwitch>
            </div>

            <div v-if="localData.permitir_liberacion_asientos" ref="liberacionSection">
                <div class="tw:my-4 tw:border-t tw:border-gray-100"></div>
                <div class="tw:grid tw:grid-cols-1 tw:md:grid-cols-2 tw:gap-4">
                    <div>
                        <BaseInputNumber
                            id="importe-monedero-abonado"
                            name="importe_monedero_abonado"
                            :label="'Importe íntegro'"
                            :value="localData.importe_monedero_abonado"
                            decimals-only
                            disallow-negatives
                            decimal-rule="decimal_opcional"
                            :step="0.01"
                            @input="val => {
                                set(localData, 'importe_monedero_abonado', val);
                                set(localData, 'porcentaje_monedero_abonado', null);
                            }"
                        />
                        <div class=" tw:rounded-md tw:px-1 tw:py-1">
                            <small class="tw:text-emerald-700 tw:tracking-wide tw:block">
                                {{ 'Importe íntegro que se le sumará al abonado en el monedero al liberar su asiento' }}
                            </small>
                        </div>
                    </div>
                    <div>
                        <BaseInputNumber
                            id="porcentaje-monedero-abonado"
                            name="porcentaje_monedero_abonado"
                            :label="'Porcentaje'"
                            :value="localData.porcentaje_monedero_abonado"
                            decimals-only
                            disallow-negatives
                            decimal-rule="decimal_opcional"
                            :step="0.01"
                            @input="val => {
                                set(localData, 'porcentaje_monedero_abonado', val);
                                set(localData, 'importe_monedero_abonado', null);
                            }"
                        />
                        <div class=" tw:rounded-md tw:px-1 tw:py-1">
                            <small class="tw:text-emerald-700 tw:tracking-wide tw:block">
                                {{ 'Porcentaje sobre el importe de venta que se le sumará al abonado en el monedero' }}
                            </small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Card>
</template>

<script setup>
    import { inject, set, ref } from 'vue';
    import { useScrollOnToggle } from '@/composables/common/useScrollOnToggle';
    import Card from '@/modules/admin/ui/Card.vue';
    import ToggleSwitch from '@/modules/admin/ui/ToggleSwitch.vue';
    import BaseInputNumber from '@/modules/admin/ui/BaseInputNumber.vue';
    import Tooltip from '@/modules/admin/ui/Tooltip.vue';

    const localData = inject('eventoFormData');

    defineProps({
        puedeConfigurarCesionTemporal: { type: Boolean, default: false },
        cesionTemporalBloqueadaPor: { type: String, default: null },
        cesionTemporalMensajeTooltip: { type: String, default: null }
    });

    const liberacionSection = ref(null);
    useScrollOnToggle(() => localData.permitir_liberacion_asientos, liberacionSection);
</script>
